import{jsx as t}from"react/jsx-runtime";import{Text as o,concatStyleSetsWithProps as e}from"@fluentui/react";const s=({bold:s,...r})=>t(o,{...r,styles:(t,o,i)=>e(t,{root:{fontWeight:s?600:void 0}},"function"==typeof r.styles?r.styles(t,o,i):r.styles)});export{s as Text};
//# sourceMappingURL=Text.js.map
